<template>
  <div class="animated fadeIn">
  
    <b-row v-if="!!menu">
      <b-col lg="12">
      <MenuInfo v-if="!menu.nutricionist_id" :menu="menu"></MenuInfo>
      <MenuInfo v-if="!!menu.nutricionist_id" :created="menu"></MenuInfo>
      </b-col>
    </b-row>

  </div>
</template>

<script>


import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Menu from '@/store/ORM/menu.js';
import CreatedMenu from '@/store/ORM/created-menu.js';
import ClientService from '@/services/client.service.js';
import MenuInfo from '@/components/MenuInfo';

export default {
  name: 'dashboard',
  components: {
    MenuInfo
  },
  data: function () {
    return {
      showTable : false,
      menu : null
    }
  },
  methods: {
  },
  created(){
    // if(this.$route.name == 'SingleMenu'){
    //   this.menu = Menu.query().whereId(parseInt(this.$route.params.id)).with('client').with('nutritionist').with('meals').first();
    // }else{
      this.menu = CreatedMenu.query().whereId(parseInt(this.$route.params.id)).with('client').with('nutricionist_id').with('meals').first();
    // }
  },
  computed: {
  },
}
</script>
